import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean;
  size?: "sm" | "md" | "lg";
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, size = "md", error, "aria-invalid": ariaInvalid, rows = 4, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    aria-invalid={ariaInvalid ?? error}
    className={cn(
      "bfrs-w-full bfrs-resize-y bfrs-rounded-lg bfrs-border bfrs-bg-surface-card bfrs-text-text-primary bfrs-outline-none bfrs-transition placeholder:bfrs-text-text-placeholder disabled:placeholder:bfrs-text-text-muted focus:bfrs-border-border-focus focus:bfrs-ring-2 focus:bfrs-ring-border-focus/20 focus-visible:bfrs-border-border-focus focus-visible:bfrs-ring-2 focus-visible:bfrs-ring-border-focus/20 disabled:bfrs-cursor-not-allowed disabled:bfrs-bg-surface-muted disabled:bfrs-text-text-disabled",
      size === "sm" && "bfrs-min-h-16 bfrs-px-3 bfrs-py-2 bfrs-text-sm bfrs-leading-5",
      size === "md" && "bfrs-min-h-24 bfrs-px-3.5 bfrs-py-3 bfrs-text-base bfrs-leading-6",
      size === "lg" && "bfrs-min-h-32 bfrs-px-4 bfrs-py-3.5 bfrs-text-base bfrs-leading-6",
      error ? "bfrs-border-danger focus:bfrs-border-danger focus:bfrs-ring-danger/15 focus-visible:bfrs-border-danger focus-visible:bfrs-ring-danger/15" : "bfrs-border-border",
      className
    )}
    {...props}
  />
));

Textarea.displayName = "Textarea";
